<template>
  <div>
    <v-row class="mx-auto">
      <v-col cols="12" md="12" class="mx-auto text-center">
        <v-avatar size="256" class="text-center">
          <v-img
            :rounded="true"
            contain
            height="480"
            class="rounded-xl"
            src="/img/mario-profile.jpg"
          />
        </v-avatar>
      </v-col>
      <v-col cols="12" md="12" class="text-center">
        <h1 v-if="true" class="mt-8 display-4 text-center font-weight-bold">
          Mario Novak
        </h1>
        <h2 v-if="true" class="mt-2 display-4 text-center">
          Software Architect
        </h2>
      </v-col>
    </v-row>
  </div>
</template>
<script lang="ts">
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'HeaderComponent',
  components: {
    //
  },
});
</script>
